import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=0c5e4f9e&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"
import style0 from "./Section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Section: require('/lasso/components/wrappers/Section.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5e4f9e')) {
      api.createRecord('0c5e4f9e', component.options)
    } else {
      api.reload('0c5e4f9e', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=0c5e4f9e&", function () {
      api.rerender('0c5e4f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/wrappers/Section.vue"
export default component.exports